<template>
  <nav class="navbar is-transparent is-spaced is-fixed-top">
    <div class="navbar-brand">
      <router-link class="navbar-item logo" to="/">
        <img :src="require('@/assets/img/logo/logo-bare.png')" />
      </router-link>
      
      <div class="navbar-burger burger" data-target="navbarBulma" @click="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div id="navbarBulma" class="navbar-menu">
      <div class="navbar-start is-hidden-touch">
        <p class="tagline">Providing technology for the next generation</p>
      </div> 
      <div class="navbar-end">
        <prismic-link v-for="menuLink in menuLinks" :key="menuLink.id" :field="menuLink.link" class="navbar-item is-uppercase">{{ $prismic.richTextAsPlain(menuLink.label) }}</prismic-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HeaderPrismic',
  data () {
    return {
      menuContent: [],
      menuLinks: []
    }
  },
  methods: {
    getMenu() {
      //Query to get menu content
      this.$prismic.client.getSingle('menu')
        .then((menuContent) => {
          this.menuContent = menuContent
          this.menuLinks = menuContent.data.menu_links
        })
    },
    toggleMenu() {
      var burger = document.querySelector(".navbar-burger"),
        menu = document.querySelector(".navbar-menu");
      if (burger.classList.contains("is-active")) {
        burger.classList.remove("is-active");
        menu.classList.remove("is-active");
      } else {
        burger.classList.add("is-active");
        menu.classList.add("is-active");
      }
    },
  },
  watch: {
    $route() {
      var burger = document.querySelector(".navbar-burger"),
        menu = document.querySelector(".navbar-menu");
      burger.classList.remove("is-active");
      menu.classList.remove("is-active");
    }
  },
  created () {
    this.getMenu()
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";

.navbar {
  background: $white;
  margin-top: 10px;
  @media screen and (max-width: $tablet) {
    padding: 10px;
  }
}

.tagline {
  font-style: italic;
}

.navbar-item {
  padding: 0.5rem 1.5rem;
  color: $navy;
  display: block;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 1;
  -webkit-transition: color 0.2s ease-in-out;
  -moz-transition: color 0.2s ease-in-out;
  -ms-transition: color 0.2s ease-in-out;
  -o-transition: color 0.2s ease-in-out;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: $teal;
    @media screen and (max-width: $tablet) {
      opacity: 1;
    }
  }
  &.router-link-active {
    color: $teal;
  }
  &.logo {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.navbar-item img {
  max-height: 3.5rem;
}
</style>
